export default __webpack_public_path__ + "static/media/next-event-card-top-background.588a777a.svg";